import {axiosInstance} from "./base";


export const getUserProfile = () => axiosInstance.get('/api/v1/user/profile');
export const getUserIdps = () => axiosInstance.get('/api/v1/user/idps');
export const getUserFactor = () => axiosInstance.get('/api/v1/user/factor');
export const getUserLogins = ({pageParam}) => axiosInstance.get('/api/v1/user/log', {
	params: {
		num: 20,
		afterToken: pageParam,
	},
});

export const linkUserIdps = (idpId, externalId) => axiosInstance.post(`/api/v1/user/idps/${idpId}`, {
	externalId,
});
export const unlinkUserIdps = (idpId) => axiosInstance.delete(`/api/v1/user/idps/${idpId}`);

export const changePassword = (password, newPassword, confirmPassword) => axiosInstance.post('/api/v1/user/credential/password', {
	password,
	newPassword,
	confirmPassword,
});

export const listUserPasswordPolicy = () => axiosInstance.get('/api/v1/user/credential/password/policy')

export const updateUserProfile = (profile) => axiosInstance.post('/api/v1/user/profile',
	profile
);


